import { Text } from '@amo/core/components/forms';
import { validatePhone } from '@amo/core/utils/validateField';
import { Field } from 'redux-form';
import {getTranslation} from "@amo/core/utils/index.js";

const NumeroTel = ({ telPortableParrainage }) => {
    return (
        <div className={'row justify-content-center'}>
            <div className={'col-lg-8 col-md-6 col-sm-6 col-12 my-2'}>
                <Field
                    label={getTranslation('informationsSubscriptor.numberPhone')}
                    component={Text}
                    type={'tel'}
                    typeFormat={'tel'}
                    name={'DemandeTarif[ListePersonnes][0][TelPortable]'}
                    placeholder={getTranslation('example', {value: '02 38 53 02 38'})}
                    validate={[validatePhone]}
                    required
                    autocomplete="tel"
                    disabled={!!telPortableParrainage}
                />
                <small className={'text-start d-block'}>
                    {getTranslation(telPortableParrainage ? 'informationsSubscriptor.parrainagePhone' : 'informationsSubscriptor.informationPhone')}
                </small>
            </div>
        </div>
    );
};

export default NumeroTel;
